import type { AiChatMessageContent, AiChatMessageRole } from './AiChatConversationResponse';

export enum AiChatResponseStatus {
  OK = 'OK',
  NO_RESPONSE = 'NO_RESPONSE',
  QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',
  CONVERSATION_LENGTH_EXCEEDED = 'CONVERSATION_LENGTH_EXCEEDED',
  ERROR = 'ERROR',
}

export type AiChatRecommendedAction = {
  type: string;
  args: Record<string, unknown>;
};

export type AiChatResponse = {
  conversationId: string;
  messages: {
    role: AiChatMessageRole;
    content: AiChatMessageContent;
  }[];
  title?: string | null;
  status: AiChatResponseStatus;
  info?: string | null;
};
